import React, { useState } from "react";
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
  closestCenter,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PopUpWatchDocument from "./PopUpWatchDocument";
import FileMimeType from "../../../../../../utils/FileMimeType";
import { AdminService } from "../../../../../../services/AdminService";
import { toast } from "react-toastify";

const SortableItem = ({
  item,
  index,
  onClickDelete,
  onClickUpload,
  onTogglePopup,
  showPopup,
  titleSection,
  className,
  handleDownload,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: 138,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="section-study-folder-menu-content-element-container-result-element"
    >
      {/* Zone draggable explicite */}
      <div className="drag-handle" {...attributes} {...listeners}>
        {titleSection === "Images" ? (
          <>
            <img
              src={process.env.REACT_APP_PROD_URL + item.imageUrl}
              alt="file"
              className="img"
              onClick={() => onTogglePopup(index)}
            />
            {showPopup && (
              <PopUpWatchDocument
                images={[
                  {
                    img: process.env.REACT_APP_PROD_URL + item.imageUrl,
                    name: item.title,
                    downloadLink: item.downloadUrl,
                    filename: item.filename,
                  },
                ]}
                initialImageIndex={0}
                onClose={() => onTogglePopup(index)}
              />
            )}
          </>
        ) : (
          <div onClick={() => handleDownload(item.downloadUrl, item.filename)}>
            <FileMimeType mimeType={item.mimeType} />
          </div>
        )}

        {item.extension === "pdf" && (
          <div className="upload-pdf-study-folder">
            <img
              src="/images/pictos/add-plus-circle-primary.svg"
              alt="file"
              className="img"
              onClick={() => onClickUpload(item.id)}
            />
          </div>
        )}
      </div>

      {/* Bouton supprimer en dehors du drag */}
      <img
        src="/images/pictos/red-cross.svg"
        alt={`delete file ${item.id}`}
        className="delete-file"
        onClick={(e) => {
          e.stopPropagation();
          onClickDelete(item.id);
        }}
      />

      <p className={className || "color-white"}>{item.title}</p>
    </div>
  );
};

const StudyFolderMenuShowElementAnnexe = ({
  fakeDataProject,
  titleSection,
  input,
  onClickDelete,
  onClickUpload,
  className,
  onDragEndDropEnd,
}) => {
  const [items, setItems] = useState(fakeDataProject);
  const [showPopups, setShowPopups] = useState(
    Array(fakeDataProject.length).fill(false)
  );

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDownload = (url, filename) => {
    if (url && filename) {
      AdminService.getFile(url, filename);
      toast.success("Téléchargement en cours");
    } else {
      toast.error("Une erreur est survenue");
    }
  };

  const togglePopup = (index) => {
    const updatedPopups = [...showPopups];
    updatedPopups[index] = !updatedPopups[index];
    setShowPopups(updatedPopups);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = items.findIndex((i) => i.id === active.id);
    const newIndex = items.findIndex((i) => i.id === over.id);

    const newItems = arrayMove(items, oldIndex, newIndex);
    setItems(newItems);
    onDragEndDropEnd(newItems);
  };

  return (
    <div className="section-study-folder-menu-content-element-container">
      <div className="section-study-folder-menu-content-element-container-element">
        <p className="text-primary paragraph_bold color-white">
          {titleSection}
        </p>
        {input}
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={items.map((i) => i.id)}
          strategy={rectSortingStrategy}
        >
          <div className="section-study-folder-menu-content-element-container-result">
            {items.map((item, index) => (
              <SortableItem
                key={item.id}
                item={item}
                index={index}
                titleSection={titleSection}
                onClickDelete={onClickDelete}
                onClickUpload={onClickUpload}
                onTogglePopup={togglePopup}
                showPopup={showPopups[index]}
                className={className}
                handleDownload={handleDownload}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default StudyFolderMenuShowElementAnnexe;
